import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { encode } from 'querystring';

@Injectable({
  providedIn: 'root',
})
export class BurbujaService {
  private httpPublicClient: HttpClient;

  constructor(
    private httpClient: HttpClient,
    private HttpBackend: HttpBackend
  ) {
    this.httpPublicClient = new HttpClient(HttpBackend);
  }

  getBurbujasActivas() {
    return this.httpClient.get(encodeURI(`${environment.apiURL}/burbujas`));
  }

  getBurbujasActivasPublic() {
    return this.httpPublicClient.get(
      encodeURI(`${environment.apiURL}/public/burbujas`)
    );
  }

  getById(burbujaId: number) {
    return this.httpClient.get(
      encodeURI(`${environment.apiURL}/burbujas/${burbujaId}`)
    );
  }

  getArbol() {
    return this.httpClient.get(
      encodeURI(`${environment.apiURL}/burbujas/arbol`)
    );
  }

  crearBurbuja(burbuja: {
    nombre: string;
    descripcion: string;
    perfilUsuario: string;
  }) {
    let perfilId: string;
    if (burbuja.perfilUsuario.toString().includes(':')) {
      perfilId = burbuja.perfilUsuario.substr(
        0,
        burbuja.perfilUsuario.indexOf(':') === -1
          ? burbuja.perfilUsuario.length
          : burbuja.perfilUsuario.indexOf(':')
      );
    } else {
      perfilId = burbuja.perfilUsuario;
    }

    const formData = new FormData();
    formData.append('nombre', burbuja.nombre.trim());
    formData.append('descripcion', burbuja.descripcion);
    formData.append('perfilUsuarioId', perfilId);

    return this.httpClient.post(
      encodeURI(`${environment.apiURL}/burbujas`),
      formData
    );
  }

  modificarBurbuja(
    burbujaId,
    burbuja: {
      nombre: string;
      descripcion: string;
      perfilUsuario: string;
    }
  ) {
    const formData = new FormData();
    formData.append('nombre', burbuja.nombre.trim());
    formData.append('descripcion', burbuja.descripcion.trim());
    formData.append('perfilUsuarioId', burbuja.perfilUsuario);

    return this.httpClient.put(
      encodeURI(`${environment.apiURL}/burbujas/${burbujaId}`),
      formData
    );
  }

  eliminarBurbuja(burbujaId: number) {
    return this.httpClient.delete(
      encodeURI(`${environment.apiURL}/burbujas/${burbujaId}`)
    );
  }

  contarTemas(burbujaId: number) {
    return this.httpClient.get(
      encodeURI(`${environment.apiURL}/burbujas/countTemas/${burbujaId}`)
    );
  }

  cambiarOrden(burbujas: any) {
    return this.httpClient.put(
      encodeURI(`${environment.apiURL}/burbujas/cambiarOrden`),
      burbujas
    );
  }
}
